import { Injectable } from '@angular/core';
// tslint:disable-next-line:ban-ts-ignore
// @ts-ignore
import * as bowser from 'bowser';

@Injectable({
  providedIn: 'root',
})
export class BrowserService {
  public info: any;

  constructor() {
    this.info = this.detect();
  }

  public satisfies(obj: { [key: string]: any }): boolean {
    return this.info.satisfies(obj);
  }

  private detect(): any {
    return bowser.getParser(window.navigator.userAgent);
  }
}
